import React, { forwardRef } from "react";
import PropTypes from "prop-types";
import classnames from "classnames/bind";

import Tooltip from "@components/tooltip";
import Counter from "@components/counter";
import Icon from "@components/icon";

import styles from "./ActionButton.scss";

const cx = classnames.bind(styles);

const ActionButton = forwardRef(
  (
    { tooltipText, active, isSmall, iconName, counter, onClick, hideTooltip },
    ref
  ) => (
    <Tooltip
      content={tooltipText}
      isWithoutWrapper
      disabled={active || isSmall || hideTooltip}
    >
      <button
        className={cx("action-button", {
          active,
          small: isSmall,
        })}
        onClick={onClick}
        ref={ref}
      >
        <Icon
          name={iconName}
          className={cx("icon")}
          size={isSmall ? "m" : "l"}
        />

        {!!counter && counter > 0 && (
          <Counter active className={cx("counter")} maxValue={9} size="medium">
            {counter}
          </Counter>
        )}
      </button>
    </Tooltip>
  )
);

ActionButton.propTypes = {
  tooltipText: PropTypes.string,
  active: PropTypes.bool,
  isSmall: PropTypes.bool,
  iconName: PropTypes.string,
  counter: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  onClick: PropTypes.func,
  hideTooltip: PropTypes.bool,
};

export default ActionButton;
